"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RENDERER_PARTY = exports.RENDERER_DEFAULT = void 0;
exports.RENDERER_DEFAULT = 'default';
exports.RENDERER_PARTY = 'party';
